module.exports = __webpack_public_path__ + "img/0Q3A7268_L_BlackMatted_MockedUp.e700f055.jpg";